import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import { StepDisplay } from './StepDisplay';
import { WizardBase } from './WizardBase';
import './wizardStyles.css';

const Wizard = ({ steps, renderer, endTransactionHandler, referenceID, insuredFullName }) => {
  const [currentSteps, setCurrentSteps] = useState(steps);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndexes, setPrevIndexes] = useState([]);
  const [clickOnDocu, setClickOnDocu] = useState(false);

  const lastIndex = steps.length - 1;

  const nextHandler = () => {
    //Add error check here

    let newSteps = [...currentSteps];
    newSteps[currentIndex].status = 'complete';

    setCurrentSteps(newSteps);
    let prevs = prevIndexes.slice();
    prevs.push(currentIndex);
    setPrevIndexes(prevs);
    setCurrentIndex(currentIndex + 1);
  };

  const skipHandler = (i) => {
    let newSteps = [...currentSteps];
    newSteps[currentIndex].status = 'complete';

    setCurrentSteps(newSteps);
    let prevs = prevIndexes.slice();
    prevs.push(currentIndex);
    setPrevIndexes(prevs);
    setCurrentIndex(i);
  };

  const showHiddenStep = (i) => {
    let newSteps = [...currentSteps];
    newSteps[i].showOnStepDisplay = true;
    setCurrentSteps(newSteps);
  };

  const hideShownStep = (i) => {
    let newSteps = [...currentSteps];
    newSteps[i].showOnStepDisplay = false;
    setCurrentSteps(newSteps);
  };

  const previousHandler = () => {
    //Add error check here
    let newSteps = [...currentSteps];
    newSteps[currentIndex].status = '';

    setCurrentSteps(newSteps);
    let prevs = prevIndexes.slice();
    const lastIndex = prevs.pop();
    setPrevIndexes(prevs);
    setCurrentIndex(lastIndex);
  };
  const completedHandler = () => {
    endTransactionHandler();
  };

  const errorHandler = () => {
    let newSteps = [...currentSteps];
    newSteps[currentIndex].status = 'error';

    setCurrentSteps(newSteps);
  };

  return (
    <Paper variant="outlined">
      <StepDisplay steps={currentSteps} currentIndex={currentIndex} />
      <div className="wizardMain">
        {currentSteps && (
          <WizardBase title={currentSteps[currentIndex].name}>
            {React.createElement(
              renderer,
              {
                referenceID: referenceID,
                skipHandler: skipHandler,
                showHiddenHandler: showHiddenStep,
                hideShownHandler: hideShownStep,
                step: currentSteps[currentIndex],
                currentIndex: currentIndex,
                lastIndex: lastIndex,
                completedHandler: completedHandler,
                previousHandler: previousHandler,
                nextHandler: nextHandler,
                errorHandler: errorHandler,
                clickOnDocu: clickOnDocu,
                setClickOnDocu: setClickOnDocu,
                insuredFullName: insuredFullName,
              },
              null
            )}
          </WizardBase>
        )}
      </div>
    </Paper>
  );
};

export default Wizard;
Wizard.propTypes = {
  steps: PropTypes.array,
};

Wizard.defaultProps = {
  steps: [],
};
